export default __webpack_public_path__ + "static/media/eg.122083da.svg";